import { Burden } from '@deqo/foundation';
import { useEffect, useMemo, useState } from 'react';
import { Component, ObjectManager } from '../../../concepts/objects';
import { useResolve } from '../../Container';
import { BoardSetting } from './BoardSetting';

export const useBoardSettingGroup = (group: string) => {
    const objects = useResolve(ObjectManager);
    const [key, setKey] = useState(0);
    const bumpKey = () => setKey(x => x + 1);

    useEffect(() => {
        const ifIsGroup = (x: Component) => x.as(BoardSetting)?.group === group;
        const off = [
            objects.on('BoardSetting', 'allocated', ([x]) => ifIsGroup(x) && bumpKey()),
            objects.on('BoardSetting', 'affected', ([x]) => ifIsGroup(x) && bumpKey()),
            objects.on('BoardSetting', 'released', () => setKey(x => x + 1)),
        ];
        return () => Burden.resolveAll(off);
    }, [group]);

    return useMemo(() => BoardSetting.readGroup(group, objects), [key, group]);
};
